interface AllowedDashboardPath {
  path: string;
  allowChildren?: boolean;
}

const ONBOARDING_ALLOWED_DASHBOARD_PATHS: AllowedDashboardPath[] = [
  { path: '/dashboard' },
  { path: '/dashboard/events', allowChildren: true },
  { path: '/dashboard/settings/profile', allowChildren: true },
  { path: '/dashboard/pricing', allowChildren: true },
  { path: '/dashboard/billing', allowChildren: true },
];

const normalizeDashboardPath = (pathname: string): string => {
  if (!pathname) return '/dashboard';
  const withoutTrailingSlash = pathname.replace(/\/+$/, '');
  return withoutTrailingSlash || '/dashboard';
};

export const isDashboardPathAllowedDuringOnboarding = (pathname: string): boolean => {
  const normalizedPath = normalizeDashboardPath(pathname);

  return ONBOARDING_ALLOWED_DASHBOARD_PATHS.some(({ path, allowChildren = false }) => {
    if (normalizedPath === path) return true;
    return allowChildren && normalizedPath.startsWith(`${path}/`);
  });
};
